// extracted by mini-css-extract-plugin
export default {"container":"_02c416d3b034a7a9","block":"_294693cf0bd8ad33"};